import config from 'config';

export const getLocalAssetUrl = <T extends string>(
  assetPath?: T,
): T extends string ? string : undefined => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return assetPath ? `${config.app.staticUrl || ''}${assetPath}` : undefined;
};
